import { ModelSagres } from "@/types/model-sagres";
import { UsuarioPerfil } from "./usuario-perfil";
import { Municipio } from "../municipio";

/**
 * Recebido da API de usuários NestJS
 * @since 20240820
 */
export class Usuario extends ModelSagres {
  ID_USUARIO: number;
  VERSAO: number;
  DATA_ULT_ALTERACAO: Date;
  USUARIO_ULT_ALTERACAO: string;
  NM_USERNAME: string;
  NOME: string;
  CPF: string;
  RG: string;
  ST_ADMIN: string;
  INATIVO: string;
  DATA_INICIO: Date;
  DATA_FIM: Date;
  NM_BAIRRO: string;
  NM_CEP: string;
  NM_COMPLEMENTO: string;
  NU_NUMERO: string;
  NM_LOGRADOURO: string;
  ID_CRP_MUNICIPIO: string;
  EMAIL: string;
  cs_tipouser: string;
  ID_ORGAO: string;
  NM_TELEFONE: string;
  DT_ULTIMOACESSO: Date;
  OAB: string;
  NR_PROTOCOLO: string;
  ID_CRP_SEXO: string;
  FL_COMUNICA_TELEFONE: boolean;
  perfis?: UsuarioPerfil[];
  CRP_MUNICIPIO?: Municipio;

  constructor(obj?: any) {
    super();
    if (obj) {
      this.ID_USUARIO = obj.ID_USUARIO;

      this.CPF = obj.CPF;
      if (obj.CRP_MUNICIPIO)
        this.CRP_MUNICIPIO = new Municipio(obj.CRP_MUNICIPIO);
      this.cs_tipouser = obj.cs_tipouser;
      if (obj.DATA_FIM) this.DATA_FIM = new Date(obj.DATA_FIM);
      if (obj.DATA_INICIO) this.DATA_INICIO = new Date(obj.DATA_INICIO);
      if (obj.DATA_ULT_ALTERACAO)
        this.DATA_ULT_ALTERACAO = new Date(obj.DATA_ULT_ALTERACAO);
      if (obj.DT_ULTIMOACESSO)
        this.DT_ULTIMOACESSO = new Date(obj.DT_ULTIMOACESSO);
      this.EMAIL = obj.EMAIL;
      this.FL_COMUNICA_TELEFONE = obj.FL_COMUNICA_TELEFONE;
      this.ID_CRP_MUNICIPIO = obj.ID_CRP_MUNICIPIO;
      this.ID_CRP_SEXO = obj.ID_CRP_SEXO;
      this.ID_ORGAO = obj.ID_ORGAO;
      this.INATIVO = obj.INATIVO;
      this.NM_BAIRRO = obj.NM_BAIRRO;
      this.NM_CEP = obj.NM_CEP ?? obj.CEP;
      this.NM_COMPLEMENTO = obj.NM_COMPLEMENTO;
      this.NM_LOGRADOURO = obj.NM_LOGRADOURO ?? obj.LOGRADOURO;
      this.NM_TELEFONE = obj.NM_TELEFONE ?? obj.TELEFONE;
      this.NM_USERNAME = obj.NM_USERNAME;
      this.NOME = obj.NOME;
      this.NR_PROTOCOLO = obj.NR_PROTOCOLO;
      this.NU_NUMERO = obj.NU_NUMERO;
      this.OAB = obj.OAB;
      if (obj.USUARIO_PERFIL)
        this.perfis = obj.USUARIO_PERFIL.map((up) => new UsuarioPerfil(up));
      this.RG = obj.RG;
      this.ST_ADMIN = obj.ST_ADMIN;
      this.USUARIO_ULT_ALTERACAO = obj.USUARIO_ULT_ALTERACAO;
      this.VERSAO = obj.VERSAO;
    }
  }
}
